import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './PrivacyInformation.module.scss';
import 'src/css/themes.scss';
import { IconSeeMore } from 'src/content/icons';
import { ConnectedVehicleRec } from 'src/models';
import { Dialog, ScrollBar } from '@framework-controls/core';
import { strings } from 'src/localization';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
}

const PrivacyInformation = (props: IProps) => {
    const [infoOpen, setInfoOpen] = useState(false);
    const toggleInfo = useCallback(() => {
        setInfoOpen(!infoOpen);
    }, [infoOpen]);

    let consentTstamp: ReactElement | null = null;
    if (props.connectedVehicle.privacyTstamp) {
        consentTstamp = <p className={css.statusLit}>{strings.DataAsOf + ' ' + props.connectedVehicle.privacyTstamp}</p>;
    }

    let consent: ReactElement | null = null;
    if (props.connectedVehicle.privacyStatusCode) {
        consent = <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.PrivacyConsent}
            </div>
            <div className={css.infoData}>
                {props.connectedVehicle.privacyStatusCode}
            </div>
            {consentTstamp}
        </span>;
    }

    let company: ReactElement | null = null;
    if (props.connectedVehicle.privacyCompanyName) {
        company = <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.PrivacyCompanyName}
            </div>
            <div className={css.infoData}>
                {props.connectedVehicle.privacyCompanyName}
            </div>
        </span>;
    }

    let description: ReactElement | null = null;
    if (props.connectedVehicle.privacyConsentName) {
        description = <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.Description}
            </div>
            <div className={css.infoData}>
                {props.connectedVehicle.privacyConsentName}
            </div>
        </span>;
    }

    let startDate: ReactElement | null = null;
    if (props.connectedVehicle.privacyStartTstamp) {
        startDate = <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.PrivacyStartDate}
            </div>
            <div className={css.infoData}>
                {props.connectedVehicle.privacyStartTstamp}
            </div>
        </span>;
    }

    let deviceType: ReactElement | null = null;
    if (props.connectedVehicle.privacyDeviceType) {
        deviceType =
        <div>
            {props.connectedVehicle.privacyDeviceType}
        </div>;
    }

    let deviceValue: ReactElement | null = null;
    if (props.connectedVehicle.privacyDeviceValue) {
        deviceValue =
        <div>
            {props.connectedVehicle.privacyDeviceValue}
        </div>;
    }

    let device: ReactElement | null = null;
    if (deviceType || deviceValue) {
        device = <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.PrivacyDevice}
            </div>
            <div className={css.infoData}>
                {deviceType}
                {deviceValue}
            </div>
        </span>;
    }

    return (
        <div className={css.block}>
            <span className={css.header}>
                <div className={css.headerRow}>
                    <div className={css.statusLit}>{strings.PrivacyConsent}</div>
                    <div className={css.icon}>
                        <IconSeeMore onClick={() => toggleInfo()} />
                    </div>
                </div>
                <div className={css.statusData}>{props.connectedVehicle.privacyStatusCode}</div>
            </span>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={infoOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.PrivacyInformation.toUpperCase()}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={() => toggleInfo()}
                onBackDropClick={() => toggleInfo()}
                width={'full'}
            >
                <ScrollBar scrollVertical>
                    <div className={css.infoRow}>
                        {consent}
                        {company}
                        {description}
                        {startDate}
                        {device}
                    </div>
                </ScrollBar>
            </Dialog>
        </div>
    );
};

export default PrivacyInformation;